* {
  margin: 0;
  padding: 0;
  box-sizing: border-box;
}

.transaction-container {
  display: flex;
  flex-direction: column;
  padding: 1rem;
  gap: 2rem;
}

.receiver-container {
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  gap: 4px;
  line-height: 1;
}

.data-container {
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  gap: 4px;
  line-height: 1;
}

.data-content {
  width: 100%;
  height: 100px;
  resize: none;
  border-radius: 0.5rem;
  padding: 0.5rem;
}

.fee-container {
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  gap: 4px;
  line-height: 1;
}

.sign-button {
  display: block;
  width: 200px;
  margin: 0 auto;
  padding: 12px;
  background-color: #1a56db;
  color: white;
  border: none;
  border-radius: 8px;
  cursor: pointer;

  &:disabled {
    background-color: #a1a1a1;
    color: #e0e0e0;
    cursor: not-allowed;
    opacity: 0.6;
    box-shadow: none;
    transform: none;
  }
}
